// 車両管理のパスかどうかを返す
export function isTrackerPath() {
  return location.pathname.indexOf('tracker') !== -1;
}



// WEBPACK FOOTER //
// ./src/utilities/trackerUtil.js